import React, { useContext, useEffect, useState } from 'react'
import { CropImageContext } from '../../../Context/CropImageContext';
import { loadImage } from '../../../lib/utils/utils';
import { v4 as uuidv4 } from 'uuid';
import ImageAdd from '../../../Assets/Add image.svg';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';

function AddCouponImage() {
    const { image, setImage, formErrors } = useContext(AddCouponFormContext);
    const { setImageToCrop, croppedImage, setCroppedImage, isImageCropped, setIsImageCropped, setModalOpen, setAspectRatio } = useContext(CropImageContext);

    const handleImageSelection = async (e) => {
        const file = e.target.files[0];
        setImageToCrop(file);
        setAspectRatio(5 / 6);
        setModalOpen(true);
        e.target.value = null;
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        setAspectRatio(5 / 6);
        setImageToCrop(file);
        setModalOpen(true);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const processFile = async (file) => {
        if(file) {
            const img = await loadImage(file);
            const selectedImage = {
                id: uuidv4(),
                url: img.src,
                file: file
            };
            setImage(selectedImage);
        }
        else {
            return;
        }
    }

    useEffect(() => {
        if(isImageCropped) {
            processFile(croppedImage);
            setIsImageCropped(false);
            setCroppedImage({});
            setModalOpen(false);
        }
        // eslint-disable-next-line
    }, [isImageCropped]);

    const [hoverOnImage, setHoverOnImage] = useState(false);
    const [buttonsVisible, setButtonsVisible] = useState(false);

    useEffect(() => {
        if(hoverOnImage) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnImage]);

    const handleDeleteImage = () => {
        setImage({});
    }

    const handleReplaceImage = async (e) => {
        setHoverOnImage(false);
        const file = e.target.files[0];
        setImageToCrop(file);
        setModalOpen(true);
        e.target.value = null;
    }

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-[26px] select-none'>
                    Add Image <span className='text-base text-[#666666]'>&#40;1080px * 1296px&#41;</span>
                </h1>

                <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.image}</p>
            </div>

            <div 
                onDrop={handleDrop} 
                onDragOver={handleDragOver} 
                onDragLeave={handleDragLeave} 
                className="p-3 flex flex-wrap gap-3 rounded-xl bg-[#F5F5F5]"
            >
                {
                    Object.keys(image).length === 0 ? 
                    <label htmlFor='product-image' className="cursor-pointer border-dashed bg-[#E5E5E5] border-2 border-[#D1D5DB] size-[140px] rounded-lg flex flex-col items-center justify-center gap-2">
                        <div className="w-12 h-12 flex items-center justify-center">
                            <img src={ImageAdd} alt="" />
                        </div>

                        <p className='font-medium text-sm text-[#4B5563] w-[90%] text-center'>
                            <span className='text-[#4F46E5]'>Click to Upload</span> or Drag or drop
                        </p>
                    </label> : 
                    <div 
                        onMouseEnter={() => setHoverOnImage(true)} 
                        onMouseLeave={() => setHoverOnImage(false)} 
                        className='relative size-[140px] rounded-lg overflow-hidden'
                    >
                        <img className='size-full object-cover' src={image.url} alt="" />

                        <div className={`${buttonsVisible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all delay-100 ease-in-out w-full h-full bg-[#00000066] absolute top-0 left-0 items-center justify-center flex flex-col gap-2`}>
                            <label htmlFor={image.id} className='select-none bg-[#FFFFFF] w-3/5 py-[6px] text-sm font-semibold rounded text-center cursor-pointer'>Replace</label>
                                        
                            <button onClick={handleDeleteImage} className='select-none bg-[#FFFFFF] w-3/5 py-[6px] text-sm font-semibold rounded'>Delete</button>

                            <input 
                                className='hidden' 
                                id={image.id} 
                                type="file" 
                                accept="image/*" 
                                onChange={handleReplaceImage} 
                            />
                        </div>
                    </div>
                }

                <input 
                    onChange={handleImageSelection} 
                    className='hidden'
                    type="file" 
                    accept="image/*" 
                    name="product-image" 
                    id="product-image" 
                />
            </div>
        </div>
    );
}

export default AddCouponImage;
